module.exports = "/_next/static/images/UB-4cc2ace5328b5c4fd4254017fcc2c00c.png";